
export const ADD_COMMAND = 'multiscene/ADD_COMMAND';
export const REMOVE_COMMAND = 'multiscene/REMOVE_COMMAND';
export const SELECT_MODE = 'multiscene/SELECT_MODE';
export const SET_INITIALIZED = 'multiscene/SET_INITIALIZED';

export default function getActions(dispatch) {
    return {
        addCommand: (name, params) => dispatch({
            type: ADD_COMMAND, name, params
        }),
        selectMode: (mode) => dispatch({
            type: SELECT_MODE, mode
        }),
        setInitialized: (value) => dispatch({
            type: SET_INITIALIZED,
            value
        }),
        removeCommand: (id) => dispatch({
            type: REMOVE_COMMAND, id
        })
    };
}
